export const siteModule = {
    HOME: "",
    COMPANY: "company",
    ITSOLUTIONS: "itsolutions",
    ITBLOGS: "itblogs"
}

export const homePage = {
    HOME1: "index2",
    HOME2: "index",
    HOME3: "index3",
}

export const innerPage = {
    ABOUT: "about",
    FAQ: "faq",
    GALLERY: "gallery",
    ICONS: "icons",
    PRICING: "pricing",
    PLAN_DETAIL: "plan",
    TEAM: "team",
    TESTIMONIALS: "testimonials",
    WHYCHOOSEUS: "why-choose-us",
    CONTACT: "contact",
    CAREERS: "careers",
    CAREERS_DETAIL: "careers/detail",
    OFFERS: "offers",
    OFFER_DETAIL: "offer",
    MISSION: "mission",
    SERVICES: "services",
    SERVICES_DETAIL: "services/detail",
    PORTFOLIO1: "portfolio/1",
    PORTFOLIO2: "portfolio/2",
    PORTFOLIO_DETAIL: "portfolio/detail",
    BLOGS_GRID: "blogs/grid",
    BLOGS_LIST_SIDEBAR: "blogs/list-sidebar",
    BLOGS_DETAIL_SIDEBAR: "blogs/detail-sidebar",
    BLOGS_DETAIL: "blogs/detail",
    SCHOOL_DETAIL:"services/school/details",
}

export function routeWith(module: string, page: string) {
    return "/"+module+"/"+page
}